import React from "react";

interface IProps {
  Item?: boolean;
}

const HtmlRenderActifToStatus: React.FC<IProps> = ({ Item }) => {
  return (
    <span >
      {Item && Item === true ? "Actif" : "Inactif"}
    </span>
  );
};

export default HtmlRenderActifToStatus;
